import { Headline3, theme } from 'aimo-ui';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { Divider } from 'styles/CommonLayoutStyles';
import { StyledWrapper } from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';
import MenuItem, { MenuItemProps } from '../../common/MenuItem';

const borderColor = isWeb ? theme.colors.black : undefined;
const borderWidth = isWeb ? 1 : undefined;

const MenuContainer = styled.View`
  padding: 0px 20px;
`;

export const MenuSection = ({
  children,
  headline,
  noDivider = false,
}: {
  children: React.ReactNode;
  headline?: string;
  noDivider?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <StyledWrapper mb={10} center={isWeb} maxWidth={isWeb ? 600 : undefined}>
      <MenuContainer>
        {headline && (
          <Headline3
            accessible={true}
            accessibilityRole="header"
            accessibilityLabel={`${t(headline)} ${t('ariaLabels.common.subsection')}`}>
            {t(headline)}
          </Headline3>
        )}
        {children}
      </MenuContainer>
      <Divider size={noDivider ? 0 : 10} />
    </StyledWrapper>
  );
};

export const MenuItemWrapped: React.FC<MenuItemProps> = ({ ...props }) => {
  return (
    <MenuItem
      borderColor={borderColor}
      borderW={borderWidth}
      withArrow
      {...props}
    />
  );
};
